import(/* webpackMode: "eager" */ "/var/www/lumi/apps/parent/src/app/global-error.tsx");
